import React from "react";
import {
  Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table
} from '@material-ui/core';
import moment from "moment";


export default class ComponentToPrint extends React.Component {

  render() {
    const earlySettledLoanList = this.props.earlySettledLoanList;
    const searchData = this.props.searchData;
    const dateRange = this.props.dateRange;


    return (
      <div>
        <h3><center><u>Loan Settled Report</u></center></h3>
        <div>&nbsp;</div>
        <h4><center>Group :{searchData.groupName}</center></h4>
        <h4><center>Factory :{searchData.factoryName}</center></h4>
        <h4><center>Route :{searchData.routeName === undefined ? "All Routes" : searchData.routeName}</center></h4>
        <h4><center>Registration No :{searchData.registrationNumber === "" ? "All Reg. No" : searchData.registrationNumber}</center></h4>
        <h4><center>Date :{moment(dateRange.startDate).format("YYYY/MM/DD")} - {moment(dateRange.endDate).format("YYYY/MM/DD")}</center></h4>
        <div>&nbsp;</div>
        <div>
          <Box minWidth={1050}>
            <TableContainer >
              <Table aria-label="caption table">
                <TableHead>
                  <TableRow>
                    <TableCell align={'left'} style={{ border: "1px #ccc solid" ,fontSize:"10px" }}>Route Name</TableCell>
                    <TableCell align={'left'} style={{ border: "1px #ccc solid" ,fontSize:"10px" }}>Reg No</TableCell>
                    <TableCell align={'left'} style={{ border: "1px #ccc solid" ,fontSize:"10px" }}>Name</TableCell>
                    <TableCell align={'left'} style={{ border: "1px #ccc solid" ,fontSize:"10px" }}>Loan Issue Date</TableCell>
                    <TableCell align={'left'} style={{ border: "1px #ccc solid" ,fontSize:"10px" }}>Settled Date</TableCell>
                    <TableCell align={'left'} style={{ border: "1px #ccc solid" ,fontSize:"10px" }}>Payment Compleated Date</TableCell>
                    <TableCell align={'left'} style={{ border: "1px #ccc solid" ,fontSize:"10px" }}>Annual Rate</TableCell>
                    <TableCell align={'right'} style={{ border: "1px #ccc solid" ,fontSize:"10px" }}>No. of Installments</TableCell>
                    <TableCell align={'right'} style={{ border: "1px #ccc solid" ,fontSize:"10px" }}>No. of Completed Installment</TableCell>
                    <TableCell align={'right'} style={{ border: "1px #ccc solid",fontSize:"10px"  }}>Loan Amount (Rs)</TableCell>
                    <TableCell align={'right'} style={{ border: "1px #ccc solid" ,fontSize:"10px" }}>Fine Interest (%)</TableCell>
                    <TableCell align={'right'} style={{ border: "1px #ccc solid" ,fontSize:"10px" }}>Early Settled Amount (Rs)</TableCell>
                    <TableCell align={'right'} style={{ border: "1px #ccc solid" ,fontSize:"10px" }}>Fine amount(Rs)</TableCell>

                  </TableRow>
                </TableHead>
                <TableBody>
                  {earlySettledLoanList.map((data, index) => (
                    <TableRow key={index}>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px #ccc solid",fontSize:"10px" }}>
                        {data.routeName}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px #ccc solid",fontSize:"10px" }}>
                        {data.registrationNumber}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px #ccc solid",fontSize:"10px" }}>
                        {data.customerName}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px #ccc solid",fontSize:"10px" }}>
                        {data.loanIssuedDate.split('T')[0]}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px #ccc solid",fontSize:"10px" }}>
                        {
                          data.earlySettledDate &&
                            data.earlySettledDate !== "0001-01-01T00:00:00" &&
                            moment(data.earlySettledDate).isValid()
                            ? moment(data.earlySettledDate).format("DD/MM/YYYY")
                            : "-"
                        }
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px #ccc solid",fontSize:"10px" }}>
                        {data.paymentCompleatedDate &&
                          data.paymentCompleatedDate !== "0001-01-01T00:00:00" &&
                          moment(data.paymentCompleatedDate).isValid()
                          ? moment(data.paymentCompleatedDate).format("DD/MM/YYYY")
                          : "-"}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px #ccc solid",fontSize:"10px" }}>
                        {data.annualRate}
                      </TableCell>
                      <TableCell align={'right'} component="th" scope="row" style={{ border: "1px #ccc solid",fontSize:"10px" }}>
                        {data.numberOfInstalments}
                      </TableCell>
                      <TableCell align={'right'} component="th" scope="row" style={{ border: "1px #ccc solid",fontSize:"10px" }}>
                        {data.numberOfCompletedInstalments}
                      </TableCell>
                      <TableCell align={'right'} component="th" scope="row" style={{ border: "1px #ccc solid",fontSize:"10px" }}>
                        {data.principalAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                      <TableCell align={'right'} component="th" scope="row" style={{ border: "1px #ccc solid",fontSize:"10px" }}>
                        {data.earlyStettleFineInterest.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                      <TableCell align={'right'} component="th" scope="row" style={{ border: "1px #ccc solid",fontSize:"10px" }}>
                        {data.capitalOutstanding.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                      <TableCell align={'right'} component="th" scope="row" style={{ border: "1px #ccc solid",fontSize:"10px" }}>
                        {data.earlySettlementFine.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </div>
      </div>
    );
  }
}
